export const selectViolations = state => state.getIn(['payment', 'violations']);
export const selectErrorKey = state => state.getIn(['payment', 'errorKey']);

export const showPaymentError = state => state.getIn(['payment_error', 'showError']);
export const paymentErrorMessage = state => state.getIn(['payment_error', 'message']);
